module.exports = __webpack_public_path__ + "img/first.c32b0968.png";